import PropTypes from 'prop-types';
import React from 'react';

const Concatenate = ({separator, children, ...rest}) => {
  const flatChildren = React.Children.toArray(children);
  const separated = flatChildren.reduce((previous, current, index) => {
    previous.push(current);
    if (index !== flatChildren.length - 1) {
      previous.push(separator(index));
    }
    return previous;
  }, []);
  return <div {...rest}>{separated}</div>;
};

Concatenate.defaultProps = {
  separator: key => <span key={key}> ⋅ </span>,
};

Concatenate.propTypes = {
  separator: PropTypes.func.isRequired,
  children: PropTypes.node,
};

export default Concatenate;
